var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnboardingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.566 17.842c-.945 2.462-3.678 4.012-6.563 4.161.139-2.772 1.684-5.608 4.209-6.563l.51.521c-1.534 1.523-2.061 2.765-2.144 3.461.704-.085 2.006-.608 3.483-2.096l.505.516ZM7.43 6.5c-1.778-.01-4.062.911-5.766 2.614A9.2 9.2 0 0 0 0 11.372c1.538-1.163 3.228-1.485 5.147-.408A22.496 22.496 0 0 1 7.43 6.5ZM12.634 24a9.14 9.14 0 0 0 2.261-1.664c1.708-1.706 2.622-4.001 2.604-5.782a24.464 24.464 0 0 1-4.466 2.296c1.077 1.92.764 3.614-.399 5.15ZM23.946.044C23.518.014 23.098 0 22.685 0 13.347 0 8.22 7.426 6.584 13.009l4.428 4.428C16.792 15.582 24 10.66 24 1.444v-.059a18.668 18.668 0 0 0-.054-1.341ZM18 8a2 2 0 1 1-.001-3.999A2 2 0 0 1 18 8Z",
    fill: "#85B440"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingIcon);
export default __webpack_public_path__ + "static/media/onboarding_icon.933270a11554c82eaf632e5cb313269d.svg";
export { ForwardRef as ReactComponent };